import { render, staticRenderFns } from "./OnboardingMilestoneStatistics.vue?vue&type=template&id=4cfa486b&scoped=true&"
import script from "./OnboardingMilestoneStatistics.vue?vue&type=script&lang=ts&"
export * from "./OnboardingMilestoneStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingMilestoneStatistics.vue?vue&type=style&index=0&id=4cfa486b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfa486b",
  null
  
)

export default component.exports